import { getAccessToken } from "../authorization/AuthorizeService";
import { MessageContext } from "../message";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
export default function FetchButton({ href, text, className }) {
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  return (
    <button
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={async () => {
        message.toggle({
          show: true,
          title: "",
          content: t("requests.overview.submitted.wait.label"),
          hideNo: true,
          hideYes: true,
          isWait: true,
          hideX: false,
        });
        fetch(`${process.env.REACT_APP_GATEWAY_URL}${href}`, {
          method: "GET",
          headers: {
            "Request-Origin": "portal",
            Authorization: "Bearer " + (await getAccessToken()),
          },
          mode: "cors",
          credentials: "include",
        })
          .then((response) => response.blob())
          .then((file) => {
            window.open(URL.createObjectURL(file)) &&
              message.toggle({
                show: false,
              });
          });
      }}
    >
      {text}
    </button>
  );
}
